import React from "react";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TimePicker from "@/common/elements/TimePicker";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import { useSelector } from "react-redux";

const JailIncidentInmateAdmitsGuilt = ({ isFieldEnable }) => {
  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Inmate Admits Guilt and Accepts Consequences</span>
      </StyledSectionHeading>

      <StyledGridRow gutter={16}>
        <StyledGridCol>
          <FormItem
            label="Accept?"
            layout="horizontal"
            labelPostion="label-right"
            paddingTop="24px"
            name="accept"
            valuePropName="checked"
          >
            <Checkbox disabled={!isFieldEnable} />
          </FormItem>
        </StyledGridCol>

        <StyledGridCol lg={7}>
          <FormItem label="Accept Officer" name="acceptByStaffID">
            <Select
              options={getOptionsFromRefList("", true, false, true)}
              disabled={!isFieldEnable}
            />
          </FormItem>
        </StyledGridCol>

        <StyledGridCol lg={5}>
          <FormItem label="Accept Date / Time" name="acceptDateTime">
            <CommonDatePicker
              format="DD/MM/YYYY HH:mm"
              disabled={!isFieldEnable}
            />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </>
  );
};

export default JailIncidentInmateAdmitsGuilt;
